import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoSchedulerDataSourceMixin from './KendoSchedulerDataSourceMixin'

export default {
    name: 'kendo-schedulerdatasource',
    mixins: [ KendoSchedulerDataSourceMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement
        return h('div')
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoSchedulerDataSource/index.js